import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { HelmetTitle } from '@games/ui';
import messages from 'intl/messages';
import { HowToSolve } from 'features/puzzle/components/HowToSolve';
import { TipsAndTricks } from 'features/puzzle/components/TipsAndTricks';

const HowToSolvePage: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className='container mx-auto mb-4'>
      <HelmetTitle message={formatMessage(messages.howToSolveNonogram)} />
      <div className='text-center text-xl my-4'>
        <HowToSolve />
        <TipsAndTricks />
      </div>
    </div>
  );
};

export default HowToSolvePage;
